export const DESKTOP_BREAKPOINT = 1024;

export function isDesktopViewport(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  return window.innerWidth >= DESKTOP_BREAKPOINT;
}
